// Subset of https://github.com/emotion-js/emotion/blob/master/packages/styled/src/tags.js
// Supporting more tags means less performance, we can add what we really need though

export type Tag = typeof tags[number];

export const tags = [
  "a",
  "article",
  "aside",
  "blockquote",
  "button",
  "div",
  "em",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hr",
  "iframe",
  "img",
  "input",
  "label",
  "li",
  "main",
  "nav",
  "ol",
  "p",
  "picture",
  "section",
  "select",
  "small",
  "span",
  "strong",
  "textarea",
  "ul",
  "i",
] as const;
